import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30;

import { getLocationObjectDetails } from "@dp/common";
import { observable, makeObservable, runInAction, computed } from "mobx";
import { persist } from "mobx-persist";
import { getMinMaxQuotes } from "../../utils";
var DeliveryModel = (_dec = persist("object"), _dec2 = persist("object"), (_class = /*#__PURE__*/function () {
  function DeliveryModel(platformUtil) {
    var isToGo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, DeliveryModel);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor, this);

    _initializerDefineProperty(this, "_selectedUserLocationCoordinates", _descriptor2, this);

    _initializerDefineProperty(this, "_locationSearchString", _descriptor3, this);

    _initializerDefineProperty(this, "_addressSuggestions", _descriptor4, this);

    _initializerDefineProperty(this, "_isSearchResultLoading", _descriptor5, this);

    _initializerDefineProperty(this, "_isSuggestionsOpen", _descriptor6, this);

    _initializerDefineProperty(this, "_isUnableDeliveryModelOpen", _descriptor7, this);

    _initializerDefineProperty(this, "_isUnableDeliveryLocationPage", _descriptor8, this);

    _initializerDefineProperty(this, "_isDeliveryRestaurantApiCallStatus", _descriptor9, this);

    _initializerDefineProperty(this, "_suiteOrApartmentNumber", _descriptor10, this);

    _initializerDefineProperty(this, "_otherDetails", _descriptor11, this);

    _initializerDefineProperty(this, "_selectedAddressType", _descriptor12, this);

    _initializerDefineProperty(this, "_selectedUserLocation", _descriptor13, this);

    _defineProperty(this, "platformUtil", void 0);

    _initializerDefineProperty(this, "_deliveryFrom", _descriptor14, this);

    _initializerDefineProperty(this, "_noOfGuests", _descriptor15, this);

    _initializerDefineProperty(this, "_nearbyRestaurants", _descriptor16, this);

    _initializerDefineProperty(this, "_deliveryRestaurantsAvailable", _descriptor17, this);

    _initializerDefineProperty(this, "_isSelectRestaurantPopupOpen", _descriptor18, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor19, this);

    _initializerDefineProperty(this, "_isAddressSelected", _descriptor20, this);

    _initializerDefineProperty(this, "_donotDeliver", _descriptor21, this);

    _initializerDefineProperty(this, "_previousRestaurantNum", _descriptor22, this);

    _initializerDefineProperty(this, "_isAddressSearchActive", _descriptor23, this);

    _initializerDefineProperty(this, "_orderId", _descriptor24, this);

    _initializerDefineProperty(this, "_isToGo", _descriptor25, this);

    _initializerDefineProperty(this, "_quoteData", _descriptor26, this);

    _initializerDefineProperty(this, "_togoDeliveryOrderDetails", _descriptor27, this);

    _initializerDefineProperty(this, "_showPickupBtn", _descriptor28, this);

    _initializerDefineProperty(this, "_togoDeliveryFetchTimesError", _descriptor29, this);

    _initializerDefineProperty(this, "_togoDeliveryUnavailableError", _descriptor30, this);

    this.platformUtil = platformUtil;
    this._isToGo = isToGo;
    makeObservable(this);
  }

  _createClass(DeliveryModel, [{
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this = this;

      runInAction(function () {
        var _sessionDetails$resta, _sessionDetails$deliv;

        _this._sessionDetails = _sessionDetails;
        _this._previousRestaurantNum = _sessionDetails === null || _sessionDetails === void 0 ? void 0 : (_sessionDetails$resta = _sessionDetails.restaurantDetails) === null || _sessionDetails$resta === void 0 ? void 0 : _sessionDetails$resta.restaurantNumber;

        if (_sessionDetails !== null && _sessionDetails !== void 0 && _sessionDetails.deliveryGroup.address1) {
          var deliveryGroup = _sessionDetails.deliveryGroup;
          _this._locationSearchString = _this.locationStringFromSessionDetails;
          _this._selectedUserLocation = {
            addressLine1: deliveryGroup.address1,
            city: deliveryGroup.city,
            state: deliveryGroup.state,
            country: deliveryGroup.country,
            zipCode: deliveryGroup.postalCode
          };

          if (_this._selectedUserLocation.addressLine1 !== undefined) {
            _this._isAddressSelected = true;
          } else {
            _this._isAddressSelected = false;
          }
        }

        if (_sessionDetails !== null && _sessionDetails !== void 0 && (_sessionDetails$deliv = _sessionDetails.deliveryGroup) !== null && _sessionDetails$deliv !== void 0 && _sessionDetails$deliv.address2) {
          _this._suiteOrApartmentNumber = _sessionDetails.deliveryGroup.address2;
        }
      });
    }
  }, {
    key: "setIsSearchResultLoading",
    value: function setIsSearchResultLoading(state) {
      var _this2 = this;

      runInAction(function () {
        _this2._isSearchResultLoading = state;
      });
    }
  }, {
    key: "setAddressSuggestionsData",
    value: function setAddressSuggestionsData(_suggestions) {
      var _this3 = this;

      runInAction(function () {
        _this3._addressSuggestions = _suggestions;
      });
    }
  }, {
    key: "setSelectedUserLocation",
    value: function setSelectedUserLocation(_obj) {
      var _this4 = this;

      runInAction(function () {
        _this4._selectedUserLocation = getLocationObjectDetails(_obj);
      });
    }
  }, {
    key: "setSelectedUserLocationCoordinates",
    value: function setSelectedUserLocationCoordinates(obj) {
      var _this5 = this;

      runInAction(function () {
        _this5._selectedUserLocationCoordinates = "".concat(obj[1], ", ").concat(obj[0]);
      });
    }
  }, {
    key: "setAppAttributes",
    value: function setAppAttributes(_appAttributes) {
      var _this6 = this;

      runInAction(function () {
        _this6._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setTogoDeliveryQuote",
    value: function setTogoDeliveryQuote(_quoteData) {
      var _this7 = this;

      runInAction(function () {
        _this7._quoteData = _quoteData;
      });
    }
  }, {
    key: "setTogoDeliveryOrderDetails",
    value: function setTogoDeliveryOrderDetails(_togoDeliveryOrderDetails) {
      var _this8 = this;

      runInAction(function () {
        _this8._togoDeliveryOrderDetails = _togoDeliveryOrderDetails;
      });
    }
  }, {
    key: "setShowTogoDeliveryFetchTimesErrorModal",
    value: function setShowTogoDeliveryFetchTimesErrorModal(data) {
      var _this9 = this;

      runInAction(function () {
        _this9._togoDeliveryFetchTimesError = data;
      });
    }
  }, {
    key: "setShowTogoDeliveryUnavailableErrorModal",
    value: function setShowTogoDeliveryUnavailableErrorModal(data) {
      var _this10 = this;

      runInAction(function () {
        _this10._togoDeliveryUnavailableError = data;
      });
    }
  }, {
    key: "isContinueButtonEnabled",
    get: function get() {
      if (this._isToGo) {
        return this._isAddressSelected;
      } else {
        return this._isAddressSelected && this._selectedAddressType !== "none";
      }
    }
  }, {
    key: "isAddressSelected",
    get: function get() {
      return this._isAddressSelected;
    },
    set: function set(state) {
      var _this11 = this;

      runInAction(function () {
        _this11._isAddressSelected = state;
      });
    }
  }, {
    key: "deliveryFrom",
    get: function get() {
      return this._deliveryFrom;
    },
    set: function set(_obj) {
      var _this12 = this;

      runInAction(function () {
        _this12._deliveryFrom = _obj;
      });
    }
  }, {
    key: "togoDeliveryRestaurantAddress",
    get: function get() {
      var _this$deliveryFrom, _this$deliveryFrom$co;

      var deliveryFrom = this.deliveryFrom;
      if (!deliveryFrom) return "";
      var contactDetail = (_this$deliveryFrom = this.deliveryFrom) === null || _this$deliveryFrom === void 0 ? void 0 : (_this$deliveryFrom$co = _this$deliveryFrom.contactDetail) === null || _this$deliveryFrom$co === void 0 ? void 0 : _this$deliveryFrom$co.address;
      var togoDeliveryLabel = "".concat(contactDetail === null || contactDetail === void 0 ? void 0 : contactDetail.street1, ", ").concat(contactDetail === null || contactDetail === void 0 ? void 0 : contactDetail.city, ", ").concat(contactDetail === null || contactDetail === void 0 ? void 0 : contactDetail.stateCode, " ").concat(contactDetail === null || contactDetail === void 0 ? void 0 : contactDetail.zipCode.toString().substring(0, 5));
      return togoDeliveryLabel;
    }
  }, {
    key: "togoDeliveryRestaurantName",
    get: function get() {
      var _this$deliveryFrom2;

      var deliveryFrom = this.deliveryFrom;
      if (!deliveryFrom) return "";
      return (_this$deliveryFrom2 = this.deliveryFrom) === null || _this$deliveryFrom2 === void 0 ? void 0 : _this$deliveryFrom2.restaurantName;
    }
  }, {
    key: "noOfGuests",
    get: function get() {
      return this._noOfGuests;
    },
    set: function set(_text) {
      var _this13 = this;

      runInAction(function () {
        _this13._noOfGuests = _text;
      });
    }
  }, {
    key: "nearbyRestaurants",
    get: function get() {
      return this._nearbyRestaurants;
    },
    set: function set(_result) {
      var _this14 = this;

      runInAction(function () {
        _this14._nearbyRestaurants = _result;
      });
    }
  }, {
    key: "deliveryRestaurantsAvailable",
    get: function get() {
      return this._deliveryRestaurantsAvailable;
    },
    set: function set(_result) {
      var _this15 = this;

      runInAction(function () {
        _this15._deliveryRestaurantsAvailable = _result;
      });
    }
  }, {
    key: "isUnableDeliveryModelOpen",
    get: function get() {
      return this._isUnableDeliveryModelOpen;
    },
    set: function set(_val) {
      var _this16 = this;

      runInAction(function () {
        _this16._isUnableDeliveryModelOpen = _val;
      });
    }
  }, {
    key: "isUnableDeliveryLocationPage",
    get: function get() {
      return this._isUnableDeliveryLocationPage;
    },
    set: function set(_val) {
      this._isUnableDeliveryLocationPage = _val;
    }
  }, {
    key: "isDeliveryRestaurantApiCallStatus",
    get: function get() {
      return this._isDeliveryRestaurantApiCallStatus;
    },
    set: function set(_val) {
      this._isDeliveryRestaurantApiCallStatus = _val;
    }
  }, {
    key: "isSelectRestaurantPopupOpen",
    get: function get() {
      return this._isSelectRestaurantPopupOpen;
    },
    set: function set(_value) {
      var _this17 = this;

      runInAction(function () {
        _this17._isSelectRestaurantPopupOpen = _value;
      });
    }
  }, {
    key: "selectedAddressType",
    get: function get() {
      return this._selectedAddressType;
    },
    set: function set(value) {
      var _this18 = this;

      runInAction(function () {
        _this18._selectedAddressType = value;
      });
    }
  }, {
    key: "isNonResidentalDeliveryAddressSelected",
    get: function get() {
      return this._selectedAddressType === "Business" || this._selectedAddressType === "Other";
    }
  }, {
    key: "suiteOrApartmentNumber",
    get: function get() {
      return this._suiteOrApartmentNumber;
    },
    set: function set(value) {
      var _this19 = this;

      runInAction(function () {
        _this19._suiteOrApartmentNumber = value;
      });
    }
  }, {
    key: "otherDetails",
    get: function get() {
      return this._otherDetails;
    },
    set: function set(value) {
      var _this20 = this;

      runInAction(function () {
        _this20._otherDetails = value;
      });
    }
  }, {
    key: "isSuggestionsOpen",
    get: function get() {
      return this._isSuggestionsOpen;
    }
  }, {
    key: "suggestionsOpen",
    set: function set(state) {
      this._isSuggestionsOpen = state;
    }
  }, {
    key: "isSearchResultLoading",
    get: function get() {
      return this._isSearchResultLoading;
    }
  }, {
    key: "addressSuggestions",
    get: function get() {
      return this._addressSuggestions;
    }
  }, {
    key: "selectedUserLocation",
    get: function get() {
      return this._selectedUserLocation;
    }
  }, {
    key: "donotDeliver",
    set: function set(_val) {
      var _this21 = this;

      runInAction(function () {
        _this21._donotDeliver = _val;
      });
    },
    get: function get() {
      return this._donotDeliver;
    }
  }, {
    key: "selectedUserLocationCoordinates",
    set: function set(_obj) {
      var _this22 = this;

      runInAction(function () {
        _this22._selectedUserLocationCoordinates = _obj;
      });
    },
    get: function get() {
      return this._selectedUserLocationCoordinates;
    }
  }, {
    key: "locationSearchString",
    set: function set(_locationSearchString) {
      var _this23 = this;

      runInAction(function () {
        _this23._locationSearchString = _locationSearchString;
      });
    },
    get: function get() {
      return this._locationSearchString;
    }
  }, {
    key: "allDeliveryAddressTypes",
    get: function get() {
      var _this$_appAttributes;

      var appAttrData = (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.deliveryAddressTypes;
      var addressTypeArray = [];

      if (appAttrData) {
        for (var _i = 0, _Object$entries = Object.entries(appAttrData); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          var typeObj = {
            value: key,
            label: value
          };
          addressTypeArray = [].concat(_toConsumableArray(addressTypeArray), [typeObj]);
        }

        return [{
          label: "Select Address Type*",
          value: "none"
        }].concat(_toConsumableArray(addressTypeArray));
      } else return [];
    }
  }, {
    key: "formatedDeliveryAddress",
    get: function get() {
      return (this._suiteOrApartmentNumber ? this._suiteOrApartmentNumber + " " : "") + this._locationSearchString;
    }
  }, {
    key: "maximumNumberOfGuestsDelivery",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3, _this$_appAttributes4, _this$_appAttributes5;

      return (_this$_appAttributes2 = this._appAttributes) !== null && _this$_appAttributes2 !== void 0 && (_this$_appAttributes3 = _this$_appAttributes2.configs) !== null && _this$_appAttributes3 !== void 0 && _this$_appAttributes3.maximumNumberOfGuests ? Number((_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.configs) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.maximumNumberOfGuests) : 99;
    }
  }, {
    key: "locationStringFromSessionDetails",
    get: function get() {
      var _this$_sessionDetails;

      var locationString = "";
      var deliveryGroup = (_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : _this$_sessionDetails.deliveryGroup;

      if (deliveryGroup !== null && deliveryGroup !== void 0 && deliveryGroup.address1) {
        locationString += deliveryGroup.address1;
      }

      if (deliveryGroup !== null && deliveryGroup !== void 0 && deliveryGroup.city) {
        locationString += ", " + deliveryGroup.city;
      }

      if (deliveryGroup !== null && deliveryGroup !== void 0 && deliveryGroup.state) {
        locationString += ", " + deliveryGroup.state;
      }

      if (deliveryGroup !== null && deliveryGroup !== void 0 && deliveryGroup.postalCode) {
        locationString += " " + deliveryGroup.postalCode;
      }

      if (deliveryGroup !== null && deliveryGroup !== void 0 && deliveryGroup.country) {
        locationString += ", " + deliveryGroup.country;
      }

      return locationString;
    }
  }, {
    key: "brandCodeInfo",
    get: function get() {
      var _this$_appAttributes6;

      return (_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : _this$_appAttributes6.concept;
    }
  }, {
    key: "previousRestaurantNumber",
    get: function get() {
      return this._previousRestaurantNum;
    }
  }, {
    key: "isAddressSearchActive",
    get: function get() {
      return this._isAddressSearchActive;
    },
    set: function set(_val) {
      var _this24 = this;

      runInAction(function () {
        _this24._isAddressSearchActive = _val;
      });
    }
  }, {
    key: "cateringDeliveryMinOrderAmount",
    get: function get() {
      var _this$_sessionDetails2;

      return (_this$_sessionDetails2 = this._sessionDetails) === null || _this$_sessionDetails2 === void 0 ? void 0 : _this$_sessionDetails2.cateringDeliveryMinOrderAmountThreshold;
    }
  }, {
    key: "checkoutShippingPriceTooltip",
    get: function get() {
      var _this$_appAttributes7, _this$_appAttributes8;

      return (_this$_appAttributes7 = this._appAttributes) === null || _this$_appAttributes7 === void 0 ? void 0 : (_this$_appAttributes8 = _this$_appAttributes7.configs) === null || _this$_appAttributes8 === void 0 ? void 0 : _this$_appAttributes8.checkout_shipping_price_tooltip;
    }
  }, {
    key: "orderId",
    get: function get() {
      return this._orderId;
    },
    set: function set(_val) {
      var _this25 = this;

      runInAction(function () {
        _this25._orderId = _val;
      });
    }
  }, {
    key: "togoDeliveryQuote",
    get: function get() {
      return this._quoteData;
    }
  }, {
    key: "togoDeliveryOrderDetails",
    get: function get() {
      return this._togoDeliveryOrderDetails;
    }
  }, {
    key: "timeEstimate",
    get: function get() {
      var quote = this._quoteData;

      if (!quote) {
        return null;
      }

      var minMaxQuotes = getMinMaxQuotes(quote);
      return "".concat(minMaxQuotes.minTime, "-").concat(minMaxQuotes.maxTime, " Minutes");
    }
  }, {
    key: "showPickupBtn",
    get: function get() {
      return this._showPickupBtn;
    },
    set: function set(data) {
      var _this26 = this;

      runInAction(function () {
        _this26._showPickupBtn = data;
      });
    }
  }, {
    key: "showTogoDeliveryFetchTimesErrorModal",
    get: function get() {
      return this._togoDeliveryFetchTimesError;
    }
  }, {
    key: "showTogoDeliveryUnavailableErrorModal",
    get: function get() {
      return this._togoDeliveryUnavailableError;
    }
  }]);

  return DeliveryModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_selectedUserLocationCoordinates", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_locationSearchString", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_addressSuggestions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_isSearchResultLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isSuggestionsOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_isUnableDeliveryModelOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_isUnableDeliveryLocationPage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_isDeliveryRestaurantApiCallStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_suiteOrApartmentNumber", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_otherDetails", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_selectedAddressType", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "none";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_selectedUserLocation", [_dec, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_deliveryFrom", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_noOfGuests", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_nearbyRestaurants", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_deliveryRestaurantsAvailable", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_isSelectRestaurantPopupOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_isAddressSelected", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_donotDeliver", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_previousRestaurantNum", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_isAddressSearchActive", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_orderId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_isToGo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_quoteData", [_dec2, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "_togoDeliveryOrderDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "_showPickupBtn", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "_togoDeliveryFetchTimesError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "_togoDeliveryUnavailableError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isContinueButtonEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isContinueButtonEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAddressSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAddressSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryFrom", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryFrom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togoDeliveryRestaurantAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "togoDeliveryRestaurantAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togoDeliveryRestaurantName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "togoDeliveryRestaurantName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noOfGuests", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "noOfGuests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nearbyRestaurants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nearbyRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryRestaurantsAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryRestaurantsAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUnableDeliveryModelOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUnableDeliveryModelOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUnableDeliveryLocationPage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUnableDeliveryLocationPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeliveryRestaurantApiCallStatus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliveryRestaurantApiCallStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSelectRestaurantPopupOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSelectRestaurantPopupOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedAddressType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedAddressType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNonResidentalDeliveryAddressSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNonResidentalDeliveryAddressSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "suiteOrApartmentNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "suiteOrApartmentNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "otherDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "otherDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSuggestionsOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSuggestionsOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSearchResultLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSearchResultLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addressSuggestions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "addressSuggestions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedUserLocation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedUserLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "donotDeliver", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "donotDeliver"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedUserLocationCoordinates", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedUserLocationCoordinates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationSearchString", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationSearchString"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allDeliveryAddressTypes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allDeliveryAddressTypes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formatedDeliveryAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formatedDeliveryAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maximumNumberOfGuestsDelivery", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maximumNumberOfGuestsDelivery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationStringFromSessionDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationStringFromSessionDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "brandCodeInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "brandCodeInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousRestaurantNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousRestaurantNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAddressSearchActive", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAddressSearchActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cateringDeliveryMinOrderAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cateringDeliveryMinOrderAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkoutShippingPriceTooltip", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkoutShippingPriceTooltip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togoDeliveryQuote", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "togoDeliveryQuote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togoDeliveryOrderDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "togoDeliveryOrderDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeEstimate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeEstimate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPickupBtn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPickupBtn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTogoDeliveryFetchTimesErrorModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showTogoDeliveryFetchTimesErrorModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTogoDeliveryUnavailableErrorModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showTogoDeliveryUnavailableErrorModal"), _class.prototype)), _class));
export { DeliveryModel as default };